<template>
  <div class="position-relative">
    <div class="d-flex align-items-center">
      <h1>Users</h1>
      <b-button
        v-b-tooltip.hover
        size="sm"
        :href="urlAddUser()"
        variant="primary"
        title="Agregar usuario"
        class="ml-auto"
      >
        <font-awesome-icon :icon="['fas', 'plus']"/> Usuario
      </b-button>
    </div>
    <b-card >
      <div class="d-flex flex-column flex-sm-row">
        <div class="">
          <b-form-group label-cols="12" label-cols-sm="4" label-cols-lg="4"  label="Buscar" label-for="input-sm">
            <b-form-input id="input-sm" v-model="search.name" @input="searching"></b-form-input>
          </b-form-group>
        </div>
        <nav aria-label="Page navigation example" class="ml-auto">
          <ul class="pagination">
            <li v-for="(item, index) in usersDynamic.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
          </ul>
        </nav>
      </div>
      <div>
        <Loading :active="loading" :is-full-page="true"></Loading>
        <b-table small
          :fields="tableHead"
          :items="usersDynamic.data"
          responsive="sm"
        >
          <!-- A custom formatted column -->
          <template #cell(created_at)="data">
            {{ $moment(data.item.created_at).format('YYYY-MM-DD HH:mm') }}
          </template>
          <template #cell(options)="data">
            <b-button v-b-tooltip.hover size="sm" :href="urlEdit(data.item)" variant="outline-primary" title="Editar">
              <font-awesome-icon :icon="['fas', 'edit']"/>
            </b-button>
            <b-button v-b-tooltip.hover size="sm" target="_blank" variant="danger" title="Eliminar" @click="confirmDelete(data)">
              <font-awesome-icon :icon="['fas', 'trash-alt']"/>
            </b-button>
          </template>
        </b-table>
      </div>

      <div class="d-flex">
        <nav class="ml-auto" aria-label="Page navigation example">
          <ul class="pagination">
            <li v-for="(item, index) in usersDynamic.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
          </ul>
        </nav>
      </div>
    </b-card>
    <div class="position-fixed d-flex w-100" style="bottom:15px;left:0">
      <b-alert
        :show="dismissCountDown"
        dismissible
        fade
        variant="success"
        @dismiss-count-down="countDownChanged"
        class="m-auto"
      >
        {{message}}
      </b-alert>
    </div>
    <b-modal
      v-if="modalDelete"
      v-model="modalDelete"
      title="Confirmar eliminación"
      header-bg-variant="danger"
      header-text-variant="light"
    >
      <div>
        Esta seguro que desea eliminar al usuario <strong>{{ this.selectedUser.item.email }}</strong>?
      </div>
      <template #modal-footer>
        <div class="d-flex">
          <b-button
            variant="light"
            size="sm"
            class="ml-auto"
            @click="modalDelete=false"
          >
            Cerrar
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            class="ml-3"
            @click="deleteUser()"
          >
            Eliminar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'ListUsers',
    components:{FontAwesomeIcon},
    props:{
      users:{
        required:true,
        type: Object
      },
      filters:{
        required:true,
        type: Object
      }
    },
    data() {
      return {
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'created_at', label: 'Creado' },
          { key: 'name', label: 'Nombre' },
          { key: 'email', label: 'Email' },
          { key: 'role', label: 'Role' },
          { key: 'options', label: 'Acciones' },
        ],
        message:'',
        dismissCountDown:0,
        loading:false,
        modalDelete:false,
        selectedUser:false,
        search:{
          name: this.filters.name
        },
        usersDynamic: this.users
      }
    },
    methods: {
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      confirmDelete(data) {
        this.selectedUser = data
        this.modalDelete = true
      },
      deleteUser() {
        this.loading = true
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/users/${this.selectedUser.item.id}/delete`
        //this.$store.dispatch('quote/setRequest', this.rq)
        this.$axios.post(url, this.selectedUser.item).then(rs => {
          this.loading = false
          this.modalDelete = false
          this.usersDynamic.data.splice(this.selectedUser.index, 1)
          this.dismissCountDown = 5
          this.message = rs.data.message
        })
        .catch(error=> {
          if (error.response) {
            this.errors = error.response.data.errors
          }  else {
            this.errors = {
              unexpected: ['Hubo un error por favor contacte al administrador']
            }
          }
          console.log('error quote', error);
          this.loading = false
        })
      },
      urlEdit(i) {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/users/${i.id}`
      },
      urlAddUser() {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/users/add`
      },
      searching() {
        if (this.search.name.length > 2) {
          this.searchUsers()
        }
      },
      async searchUsers() {
        this.loading = true
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/users-search`
        //this.$store.dispatch('quote/setRequest', this.rq)
        this.$axios.get(url, {params: this.search}).then(rs => {
          this.loading = false
          this.usersDynamic = rs.data.data
        })
        .catch(error=> {
          if (error.response) {
            this.errors = error.response.data.errors
          }  else {
            this.errors = {
              unexpected: ['Hubo un error por favor contacte al administrador']
            }
          }
          console.log('error quote', error);
          this.loading = false
        })
      }
    }
  }
</script>